module.exports = __webpack_public_path__ + "static/media/boquilla3.e264079b.png";